import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';

const Onboarding = lazyWithPreload(() => import('@src/pages/onboarding'));
const OnboardingRemittance = lazyWithPreload(() => import('@src/pages/onboardingRemittance'));

const routesData = [
  { path: Path.Onboarding, component: <Onboarding /> },
  { path: Path.OnboardingRemittance, component: <OnboardingRemittance /> }
];

export const onboardingRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));
